import { getAppConfig } from './getAppConfig'

export interface GetLoanApplicationUrlOptions {
    cam?: string
    clickId: string
    clickQuery: Record<string, string>
    customerId: string
    customerOrigin?: string
    customerType?: string
    dailyId: string
    gclid?: string
    k?: string
    loanAmount: number
    loanId: string
    loanTerm: number
    m?: string
    permanentId: string
    propositionId: string
    rowNumber: number
    score?: number
    thirdPartyReference?: string
    visitGuid: string
    whitelabelName: string
}

export function getLoanApplicationUrl(
    options: GetLoanApplicationUrlOptions
): string {
    const appConfig = getAppConfig()

    const url = new URL(
        `${appConfig.LOANS_CLICK_OUT_URL}loan-application/${options.loanId}/`
    )

    const query = {
        propositionId: options.propositionId,
        partner: options.whitelabelName,
        hds: options.score,
        visitGuid: options.visitGuid,
        dailyId: options.dailyId,
        permanentId: options.permanentId,
        loanTerm: options.loanTerm,
        loanAmount: options.loanAmount,
        m: options.m,
        k: options.k,
        cam: options.cam,
        gclid: options.gclid,
        customerId: options.customerId,
        customerType: options.customerType,
        clickId: options.clickId,
        customerOrigin: options.customerOrigin,
        client: 'web',
        platform: 'web',
        score: options.score,
        thirdPartyReference: options.thirdPartyReference,
        rowNumber: options.rowNumber,
        ...(options.clickQuery || {}),
    } as const

    Object.keys(query).forEach(key => {
        const queryKey = key as keyof typeof query
        const queryValue = query[queryKey]

        if (queryValue != null) {
            url.searchParams.set(key, `${queryValue}`)
        }
    })

    return url.toString()
}
